<!-- hidden label to calculate if there is a label or not -->
<app-label-inflator #labelCalculator hidden [labelComponentInterface]="card"></app-label-inflator>

<div class="full-image-card-container" #productCard>
  <!-- Image -->
  <app-asset
    *ngIf="viewModel.hasAsset$ | async; else fallbackIcon"
    class="card-full-image-asset"
    [asset]="card | method: 'getAsset'"></app-asset>
  <ng-template #fallbackIcon>
    <img class="card-fallback-icon" [src]="viewModel.assetFallBackIconUrl$ | async" alt="" />
  </ng-template>
  <div class="full-image-overlay"></div>

  <!-- card content -->
  <div class="marketing-card-container full-image-card" fxLayout="column">
    <div class="top-row" fxLayout="row" [style.height.%]="16">
      <app-card-number #num [style.width]="num.width | async" [card]="card" [index]="index"> </app-card-number>
      <app-asset
        *ngFor="let badge of card | method: 'getBadges'"
        class="full-image-badge-asset"
        [style.width]="num.width | async"
        [asset]="badge.image"></app-asset>
      <div fxFlex>
        <app-card-price
          class="card-price"
          [ngClass]="{
            'black-shadow': !(this | method: 'isDarkTextColor'),
            'white-shadow': (this | method: 'isDarkTextColor')
          }"
          [card]="card"></app-card-price>
      </div>
    </div>
    <div class="product-info" fxFlex fxLayout="column" fxLayoutAlign="end stretch">
      <div
        class="name-desc"
        [ngStyle]="{ color: card | method: 'getCardTextColor' }"
        [ngClass]="{
          'black-shadow': !(this | method: 'isDarkTextColor'),
          'white-shadow': (this | method: 'isDarkTextColor')
        }"
        fxLayout="column"
        fxLayoutAlign="end stretch"
        fxFlex>
        <app-label-inflator
          *ngIf="labelCalculator.currentLabelText$ | async | exists"
          [style.display]="'block'"
          [style.align-self]="'flex-end'"
          [labelComponentInterface]="card"
          [fitTextParentContainer]="productCard"
          [fitTextPercentageOfParent]="this | method: 'getLabelPercentage'"
          [fitTextDisabled]="false">
        </app-label-inflator>
        <div fxFlex="10">
          <div
            class="marketing-card-product-name"
            appFitText
            [percentageOfParent]="this | method: 'getProductNameTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getProductName' }}
          </div>
        </div>
        <div
          *ngIf="card | method: 'getProductDesc'"
          class="marketing-card-product-desc"
          [ngStyle]="{
            '-webkit-line-clamp': cardCount < 9 ? '4' : '3'
          }"
          appFitText
          [percentageOfParent]="this | method: 'getProductDescTextPercentage'"
          [parentContainer]="productCard">
          {{ card | method: 'getProductDesc' }}
        </div>
      </div>
      <div
        *ngIf="card | method: 'getIsThcAndCbdProduct'"
        class="thc-cbd-size"
        [ngStyle]="{ color: card | method: 'getCardTextColor' }"
        [ngClass]="{
          'black-shadow': !(this | method: 'isDarkTextColor'),
          'white-shadow': (this | method: 'isDarkTextColor')
        }"
        [style.max-height.%]="5"
        fxLayout="row"
        fxLayoutAlign="space-between">
        <div [style.display]="(card | method: 'getIsCannabinoidRange') ? 'block' : 'contents'">
          <div
            class="marketing-card-product-thc"
            appFitText
            [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getThcString' }}
          </div>
          <div
            class="marketing-card-product-cbd"
            appFitText
            [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getCbdString' }}
          </div>
        </div>
        <div
          class="marketing-card-product-size"
          appFitText
          [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
          [parentContainer]="productCard">
          {{ card | method: 'getSizeString' }}
        </div>
      </div>
    </div>
  </div>
</div>
